<div class="load-calc-wrap" [ngClass]="{'p-0':isLoadCalculateOnly}">
  <div class="main-content" *ngIf="!isLoadCalculateOnly">
    <div class="container">
      <div class="top-head">
        <h1 *ngIf="!showForm3"><img *ngIf="!showForm1" (click)="gotoStep(1,false)"
           loading="lazy" [src]="environment?.blobUrl+'/assets/icons/back-icon.svg'" alt="Back | Luminous">
          Load Calculator</h1>
        <h2 *ngIf="showForm3">
          Recommendation for your ideal UPS Batteries</h2>
        <div class="probar-wrap text-end" *ngIf="!showForm3">
          <div class="progress">
            <div class="progress-bar" [ngClass]="{'w-25': showForm1, 'w-75' : showForm2 }" role="progressbar"
              aria-valuenow="50" aria-valuemin="0" aria-valuemax="100">
            </div>
          </div>
          <span *ngIf="showForm1">Step 1/2</span>
          <span *ngIf="showForm2">Step 2/2</span>
        </div>
      </div>
    </div>
  </div>
  <div class="load-main" [ngClass]="{'py-3':isLoadCalculateOnly}">
    <div class="container">
      <div class="closeDiv mt-5 position-relative">
        <button type="button" class="close position-absolute dialogClose" (click)="closeDialog()" aria-label="Close">
          <img width="20" height="20" loading="lazy"[src]="environment?.blobUrl+'/assets/icons/close.svg'" alt="Close | Luminous" class="close">
        </button>
      </div>
      <div class="load-calc1" *ngIf="showForm1">
        <h2>{{isLoadCalculateOnly?'Calculate Load': '1. Define Load Requirement'}}</h2>
        <div class="load-row d-none d-md-block">
          <div class="row">
            <div class="col-md-4 col-xl-3">
              <div class="load-col">
                <ul class="items-name">
                  <ng-container *ngFor="let categ of subCategoriesList">
                    <li class="nextarrow"
                      [ngClass]="fetchClassNameByName(categ.subCategoryName,activeCateg == categ.subCategoryName)"
                      (click)="selectSubCateg(categ.subCategoryName)">
                      <p>{{categ.subCategoryName}} {{getSelectedQuantityCount(categ)}}</p>
                    </li>
                  </ng-container>
                </ul>
              </div>
            </div>
            <div class="col-md-8 col-xl-9 row height-fit-box">
              <div class="load-col col-6" *ngFor="let categProduct of subCategoriesList | filterCateg : activeCateg">
                <ul class="items-list">
                  <li>
                    <p>{{categProduct?.productName}} {{categProduct?.watts}}W</p>
                    <label>
                      <span
                        [ngClass]="getCount(categProduct?.productName,categProduct?.watts) < 1 ? 'removePointer' : ''"
                        (click)="handleWatt('minus', categProduct?.productName, categProduct?.watts)"> <img
                         loading="lazy" [src]="environment?.blobUrl+'/assets/icons/minus-load.svg'" alt="Minus Button | Luminous"></span>
                      <span>{{getCount(categProduct?.productName,categProduct?.watts) ?
                        getCount(categProduct?.productName,categProduct?.watts) : 0}}</span>
                      <span><img  loading="lazy" [src]="environment?.blobUrl+'/assets/icons/plus-load.svg'" alt="Plus Button | Lumnious"
                          (click)=" handleWatt('add', categProduct?.productName, categProduct?.watts)"></span>
                    </label>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="mobile-items-list d-block d-md-none">
          <div class="main" *ngFor="let categ of subCategoriesList; let i = index">
            <div class="head arrow" (click)="accordionHandler(i, categ.subCategoryName)"
              [ngClass]="{'active activeAccordion': openAccordionIndex === i}">
              <img  loading="lazy" [src]="getImageByName(categ.subCategoryName,openAccordionIndex === i)" [alt]="categ.subCategoryName">
              <p>{{categ.subCategoryName}} {{getSelectedQuantityCount(categ)}}</p>
            </div>
            <ul class="items-list">
              <li *ngFor="let categProduct of subCategoriesList | filterCateg : activeCateg">
                <p>{{categProduct?.productName}} {{categProduct?.watts}}W</p>
                <label>
                  <span [ngClass]="getCount(categProduct?.productName,categProduct?.watts) < 1 ? 'removePointer' : ''"
                    (click)="handleWatt('minus', categProduct?.productName, categProduct?.watts)"> <img
                     loading="lazy" [src]="environment?.blobUrl+'/assets/icons/minus-load.svg'" alt="Minus Button | Luminous"></span>
                  <span>{{getCount(categProduct?.productName,categProduct?.watts) ?
                    getCount(categProduct?.productName,categProduct?.watts) : 0}}</span>
                  <span><img  loading="lazy" [src]="environment?.blobUrl+'/assets/icons/plus-load.svg'" alt="Plus Button | Luminous"
                      (click)=" handleWatt('add', categProduct?.productName, categProduct?.watts)"></span>
                </label>
              </li>
            </ul>
          </div>
        </div>
        <div class="form">
          <form [formGroup]="form1">
            <div class="cst-form-group">
              <mat-form-field appearance="outline">
                <mat-label>Total load (W)</mat-label>
                <input matInput [readonly]="true" type="text" formControlName="totalWatts">

              </mat-form-field>
            </div>
            <div class="cst-form-group">
              <mat-form-field appearance="outline">
                <mat-label>Average running load (%)</mat-label>
                <mat-select formControlName="avgRunningLoadPercent">
                  <mat-option *ngFor="let item of loadPercent" [value]="item.value">
                    {{item.percentname}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <!-- {{form1.valid}} -->
            <div class="cst-form-group  text-center">
              <button class="primaryBtn nextarrow" [disabled]="!form1.valid"
                (click)="submitForm1();$event.preventDefault()">Next</button>
              <!-- <a href="" class="back-btn arrow d-inline-block d-md-none">Back</a> -->
            </div>
          </form>
        </div>
      </div>

      <div class="load-calc2" *ngIf="showForm2">
        <h3>2. Define your backup requirement</h3>
        <div class="hous-bar">
          <!-- <div class="show-time mb-5">
            <input type="number" [(ngModel)]="value">
          </div> -->
          <div class="pt-5">
            <ngx-slider [(value)]="value" [options]="options"></ngx-slider>
          </div>
        </div>
        <div class="btn-main">
          <a class="primaryBtn nextarrow text-center" (click)=" submitForm2();$event.preventDefault()">Next</a>
          <a (click)="gotoStep(1,false)" class="back-btn tarrow d-block d-md-none">Back</a>
        </div>
      </div>
      <div class="load-calc3" *ngIf="showForm3">
        <div class="load-row">
          <div class="load-col" (click)="goToRecommendedProd('Inverter')" role="button">
            <div class="head">
              <img  loading="lazy" [src]="environment?.blobUrl+'/assets/images/load-calc/inverter.webp'" alt="Inverter | Luminous">
            </div>
            <div class="description">
              <p>Inverter VA Rating</p>
              <h3>{{loadCalculatorResponseInfo.inverter_VA_Rating}} VA</h3>
            </div>
          </div>
          <div class="load-col" (click)="goToRecommendedProd('Battery')" role="button">
            <div class="head">
              <img  loading="lazy" [src]="environment?.blobUrl+'/assets/images/load-calc/battery.webp'" alt="Battery | Luminous">
            </div>
            <div class="description">
              <p>Battery Capacity & Batteries (Qty.)</p>
              <h3>{{loadCalculatorResponseInfo.battery_Capacity}} AH &
                {{loadCalculatorResponseInfo.no_Of_Batteries}} x 12V battery
              </h3>
            </div>
          </div>
        </div>
        <div class="btn-main">
          <a *ngIf="utils.screenSizeObj.width >= 768" (click)="gotoStep(1,false)" class="btnWhite text-center">Calculate
            Again</a>
          <a (click)="goToRecommendedProd()" class="primaryBtn nextarrow text-center">Next</a>
          <a *ngIf="utils.screenSizeObj.width < 768" (click)="gotoStep(1,false)" class="btnWhite text-center">Calculate
            Again</a>
        </div>
      </div>
    </div>
  </div>
</div>
